import React from 'react'

export default function Lab_template() {
  return (
    <div>404 this page is removed</div>
  )
}
